import categoriesContent from "./content/categories";
import previewsContent from "./content/previews";
import {categoriesContentType, titlesContentType, descriptionsContentType} from "./types"

export default function getContantPage(service): {
    title: string,
    categories: categoriesContentType, 
    titles: titlesContentType, 
    descriptions: descriptionsContentType,
    previews: any
} {
    return {
        title: 'Resize Image:',
        previews: previewsContent,
        ...categoriesContent(service)
    };
}
